const KIBIBYTE = 1024;
const MEBIBYTE = KIBIBYTE * KIBIBYTE;

export const formatReceiptFileSize = (size: number): string => {
    if (size < KIBIBYTE) {
        return `${size} Б`;
    }

    if (size < MEBIBYTE) {
        return `${Math.round(size / KIBIBYTE)} КБ`;
    }

    const mebibytes = Math.round((size / MEBIBYTE) * 10) / 10;

    return `${String(mebibytes).replace('.', ',')} МБ`;
};
